import fp from "lodash/fp";

import { withResetState } from "store/hocs";

import { editUserConstants } from "./editUser.constants";

const initialState = {
	loadingHierarchy: false,
	hierarchy: {},
	hierarchyState: {},
};

export const getEditUserState = state => state.editUser;

// prettier-ignore
const selector = property =>
	fp.flow(getEditUserState, fp.property(property));

export const getLoadingHierarchy = selector("loadingHierarchy");

export const getHierarchy = selector("hierarchy");

export const getHierarchyState = selector("hierarchyState");

function editUser(state = initialState, action) {
	switch (action.type) {
		case editUserConstants.LOAD_HIERARCHY_REQUEST:
			return {
				...state,
				loadingHierarchy: true,
			};
		case editUserConstants.LOAD_HIERARCHY_SUCCESS:
			return {
				...state,
				loadingHierarchy: false,
				hierarchy: action.hierarchy,
				hierarchyState: {},
			};
		case editUserConstants.LOAD_HIERARCHY_FAILURE:
			return {
				...state,
				loadingHierarchy: false,
				error: action.error,
			};
		default:
			return state;
	}
}

export default withResetState({ initialState })(editUser);
